import React from "react";
import styled from "styled-components";

const Container = styled.div`
  flex-grow: 1;
  padding: 0 40px;
  overflow: hidden;

  @media (max-width: 1250px) {
    padding: 0;
  }
`;

const Iframe = styled.iframe`
  border: 0;
`;

interface EmbeddedReportProps {
  reportHTMLContent: string;
}

const EmbeddedReport = ({ reportHTMLContent }: EmbeddedReportProps) => (
  <Container>
    <Iframe srcDoc={reportHTMLContent} width="100%" height="100%" />
  </Container>
);

export default EmbeddedReport;
